export const useQueryParams = (): {
  [param: string]: string;
} => {
  return Object.fromEntries(new URLSearchParams(window.location.href.split('#')[1].split('?')[1]));
};
